import React from "react"
import EmptyCartShowcaseModule from "./GCSanityModules/EmptyCartShowcaseModule"
import ContentMapper, {
    type ComponentMap,
    type Props
} from "@/src/components/ContentMapper"

const componentMap: ComponentMap = {
    "GC-EmptyCartShowcaseModule": EmptyCartShowcaseModule
}

const ContentMapperCheckout: React.FC<Omit<Props, "componentMap">> = props => (
    <ContentMapper componentMap={componentMap} {...props} />
)

export default ContentMapperCheckout
